// Modo demonstração da tela "Nova campanha": só em desenvolvimento (`import.meta.env.DEV`) e com
// `?demo=1` na URL. Não chama a Meta nem o backend de gestão, para ver e testar a tela sem
// reautorizar a conexão com `ads_management`. No build de produção este caminho nunca roda.

import { draftSummary } from './metaCampaignForm.js'

const goal = (value, label, destinations, extra = {}) => ({
  value, label, destinations, needs_page: false, needs_pixel: false, ...extra,
})
const MESSAGING = ['MESSENGER', 'WHATSAPP', 'INSTAGRAM_DIRECT']

export const DEMO_OPTIONS = {
  currency: 'BRL',
  destinations: {
    WEBSITE: 'Site', ON_AD: 'Formulário instantâneo', MESSENGER: 'Messenger', WHATSAPP: 'WhatsApp',
    INSTAGRAM_DIRECT: 'Direct do Instagram', INSTAGRAM_PROFILE: 'Perfil do Instagram',
    ON_POST: 'Publicação', ON_VIDEO: 'Vídeo', ON_PAGE: 'Página do Facebook',
  },
  objectives: [
    { value: 'OUTCOME_AWARENESS', label: 'Reconhecimento', goals: [
      goal('REACH', 'Alcance máximo de pessoas', [null]),
      goal('IMPRESSIONS', 'Máximo de impressões', [null]),
      goal('AD_RECALL_LIFT', 'Lembrança do anúncio', [null]),
    ] },
    { value: 'OUTCOME_TRAFFIC', label: 'Tráfego', goals: [
      goal('LINK_CLICKS', 'Cliques no link', ['WEBSITE']),
      goal('LANDING_PAGE_VIEWS', 'Visualizações da página de destino', ['WEBSITE']),
      goal('CONVERSATIONS', 'Conversas', MESSAGING, { needs_page: true }),
      goal('PROFILE_VISIT', 'Visitas ao perfil do Instagram', ['INSTAGRAM_PROFILE']),
    ] },
    { value: 'OUTCOME_ENGAGEMENT', label: 'Engajamento', goals: [
      goal('POST_ENGAGEMENT', 'Engajamento com a publicação', ['ON_POST']),
      goal('THRUPLAY', 'Reproduções completas do vídeo', ['ON_VIDEO']),
      goal('PAGE_LIKES', 'Curtidas na Página', ['ON_PAGE'], { needs_page: true }),
      goal('CONVERSATIONS', 'Conversas', MESSAGING, { needs_page: true }),
    ] },
    { value: 'OUTCOME_LEADS', label: 'Cadastros (leads)', goals: [
      goal('LEAD_GENERATION', 'Leads por formulário instantâneo', ['ON_AD'], { needs_page: true }),
      goal('OFFSITE_CONVERSIONS', 'Conversões no site', ['WEBSITE'], { needs_pixel: true }),
      goal('CONVERSATIONS', 'Conversas', MESSAGING, { needs_page: true }),
    ] },
    { value: 'OUTCOME_SALES', label: 'Vendas', goals: [
      goal('OFFSITE_CONVERSIONS', 'Conversões no site', ['WEBSITE'], { needs_pixel: true }),
      goal('VALUE', 'Valor das conversões', ['WEBSITE'], { needs_pixel: true }),
      goal('CONVERSATIONS', 'Conversas', MESSAGING, { needs_page: true }),
    ] },
  ],
  pages: [{ id: '101', name: 'Loja Exemplo' }, { id: '102', name: 'Filial Centro' }],
  instagram: [{ id: '501', name: 'loja_exemplo' }, { id: '502', name: 'filial_centro' }],
  ad: {
    image_max_mb: 10,
    video_max_mb: 100,
    cta_labels: {
      LEARN_MORE: 'Saiba mais', SHOP_NOW: 'Comprar', SIGN_UP: 'Cadastre-se', CONTACT_US: 'Fale conosco',
      BOOK_TRAVEL: 'Reservar', DOWNLOAD: 'Baixar', GET_QUOTE: 'Solicitar orçamento', SUBSCRIBE: 'Inscrever-se',
      APPLY_NOW: 'Candidate-se', ORDER_NOW: 'Pedir agora', GET_OFFER: 'Obter oferta',
      WHATSAPP_MESSAGE: 'Enviar mensagem no WhatsApp', MESSAGE_PAGE: 'Enviar mensagem', LIKE_PAGE: 'Curtir',
      NO_BUTTON: 'Sem botão',
    },
    destinations: {
      WEBSITE: { ctas: ['LEARN_MORE', 'SHOP_NOW', 'SIGN_UP', 'CONTACT_US', 'BOOK_TRAVEL', 'DOWNLOAD', 'GET_QUOTE', 'SUBSCRIBE', 'APPLY_NOW', 'ORDER_NOW', 'GET_OFFER', 'NO_BUTTON'], needs_link: true, needs_form: false },
      ON_AD: { ctas: ['SIGN_UP', 'APPLY_NOW', 'GET_QUOTE', 'SUBSCRIBE', 'DOWNLOAD', 'LEARN_MORE', 'GET_OFFER'], needs_link: false, needs_form: true },
      MESSENGER: { ctas: ['MESSAGE_PAGE'], needs_link: false, needs_form: false },
      INSTAGRAM_DIRECT: { ctas: ['MESSAGE_PAGE'], needs_link: false, needs_form: false },
      WHATSAPP: { ctas: ['WHATSAPP_MESSAGE'], needs_link: false, needs_form: false },
      ON_PAGE: { ctas: ['LIKE_PAGE', 'NO_BUTTON'], needs_link: false, needs_form: false },
      default: { ctas: ['LEARN_MORE', 'NO_BUTTON'], needs_link: false, needs_form: false },
    },
  },
  pixels: [{ id: '201', name: 'Pixel da loja' }],
  audiences: [
    { id: '301', name: 'Clientes (lista)' },
    { id: '302', name: 'Visitantes 30 dias' },
    { id: '303', name: 'Compradores' },
  ],
  utm_template: { source: 'facebook', medium: 'paid_social', campaign: '{{campaign.name}}', content: '{{ad.name}}', term: '' },
  warnings: [],
}

// Listas de exemplo maiores só para testar a busca. No uso real a busca consulta a Meta ao vivo
// (qualquer país, região, cidade ou interesse), sem lista pré-definida.
const STATES = [
  'Acre', 'Alagoas', 'Amapá', 'Amazonas', 'Bahia', 'Ceará', 'Distrito Federal', 'Espírito Santo', 'Goiás',
  'Maranhão', 'Mato Grosso', 'Mato Grosso do Sul', 'Minas Gerais', 'Pará', 'Paraíba', 'Paraná', 'Pernambuco',
  'Piauí', 'Rio de Janeiro', 'Rio Grande do Norte', 'Rio Grande do Sul', 'Rondônia', 'Roraima', 'Santa Catarina',
  'São Paulo', 'Sergipe', 'Tocantins',
]
const CITIES = [
  ['São Paulo', 'São Paulo'], ['Guarulhos', 'São Paulo'], ['Campinas', 'São Paulo'], ['Santos', 'São Paulo'],
  ['Ribeirão Preto', 'São Paulo'], ['Rio de Janeiro', 'Rio de Janeiro'], ['Niterói', 'Rio de Janeiro'],
  ['Belo Horizonte', 'Minas Gerais'], ['Contagem', 'Minas Gerais'], ['Betim', 'Minas Gerais'],
  ['Ribeirão das Neves', 'Minas Gerais'], ['Uberlândia', 'Minas Gerais'], ['Juiz de Fora', 'Minas Gerais'],
  ['Montes Claros', 'Minas Gerais'], ['Sabará', 'Minas Gerais'], ['Santa Luzia', 'Minas Gerais'],
  ['Curitiba', 'Paraná'], ['Londrina', 'Paraná'], ['Porto Alegre', 'Rio Grande do Sul'], ['Caxias do Sul', 'Rio Grande do Sul'],
  ['Florianópolis', 'Santa Catarina'], ['Joinville', 'Santa Catarina'], ['Salvador', 'Bahia'], ['Fortaleza', 'Ceará'],
  ['Recife', 'Pernambuco'], ['Brasília', 'Distrito Federal'], ['Goiânia', 'Goiás'], ['Manaus', 'Amazonas'],
  ['Belém', 'Pará'], ['Vitória', 'Espírito Santo'], ['Natal', 'Rio Grande do Norte'], ['São Luís', 'Maranhão'],
]
const GEO = [
  { key: 'BR', name: 'Brasil', type: 'country', country_code: 'BR' },
  { key: 'PT', name: 'Portugal', type: 'country', country_code: 'PT' },
  { key: 'US', name: 'Estados Unidos', type: 'country', country_code: 'US' },
  { key: 'AR', name: 'Argentina', type: 'country', country_code: 'AR' },
  ...STATES.map((name, i) => ({ key: `BR:${i + 1}`, name, type: 'region', country_code: 'BR' })),
  ...CITIES.map(([name, region], i) => ({ key: String(2400000 + i), name, type: 'city', country_code: 'BR', region })),
]
const INTEREST_NAMES = [
  'Moda', 'Fitness', 'Viagens', 'Tecnologia', 'Culinária', 'Empreendedorismo', 'Marketing digital', 'Futebol',
  'Música', 'Cinema', 'Games', 'Saúde e bem-estar', 'Beleza', 'Decoração', 'Imóveis', 'Automóveis', 'Educação',
  'Finanças pessoais', 'Investimentos', 'Pets', 'Maternidade', 'Casamento', 'Fotografia', 'Livros', 'Sustentabilidade',
  'Corrida', 'Musculação', 'Yoga', 'Gastronomia', 'Restaurantes', 'Compras online', 'Smartphones', 'Inteligência artificial',
]
const INTERESTS = INTEREST_NAMES.map((name, i) => ({ id: String(6000 + i), name }))

const norm = (s) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()

export const isDemo = (search) =>
  Boolean(import.meta.env?.DEV) && new URLSearchParams(search).get('demo') === '1'

export const demoOptions = async () => DEMO_OPTIONS

export const demoLeadForms = async () => ({
  forms: [{ id: '801', name: 'Pedido de orçamento', status: 'ACTIVE' }, { id: '802', name: 'Newsletter', status: 'ACTIVE' }],
  warning: null,
})

// Mesmo contrato do envio real: devolve { id }. Valida só o básico, como o backend faria.
export async function demoUpload({ kind, file }) {
  await new Promise((resolve) => { setTimeout(resolve, 400) })
  const limit = (kind === 'image' ? DEMO_OPTIONS.ad.image_max_mb : DEMO_OPTIONS.ad.video_max_mb) * 1024 * 1024
  if (file.size > limit) throw new Error('Arquivo maior que o limite permitido.')
  return { kind, id: kind === 'image' ? `demohash${Math.random().toString(36).slice(2, 10)}` : String(Date.now()), name: file.name }
}

export async function demoSearch({ kind, q }) {
  const list = kind === 'geo' ? GEO : INTERESTS
  return list.filter((x) => norm(x.name).includes(norm(q)))
}

// Mesmo formato da resposta do backend: `preview.after` = resumo do que seria enviado.
export async function demoCreate(form, confirm) {
  const after = draftSummary(form)
  if (!confirm) return { done: false, needs_confirm: true, preview: { after } }
  return {
    done: true, needs_confirm: false,
    preview: { after: { ...after, campaign_id: 'DEMO-1', adset_id: 'DEMO-2', creative_id: 'DEMO-3', ad_id: 'DEMO-4' } },
  }
}
